/**
 * Контроль наявності підписаної первинки (0429, 2026-08-17).
 * Опція організації: галочка + попап «список документів контролю».
 */
import { api } from './client';

export type SignStatus = 'SIGNED_EDO' | 'SIGNED_SCAN' | 'SIGNED_PAPER' | 'UNSIGNED';

export interface SignControlSettings {
  enabled: boolean;
  paper_original: boolean;
  types: string[];
  default_types: string[];
  catalog: { group: string; types: string[] }[];
}

export interface UnsignedRow {
  document_type: string;
  document_id: string;
  organization_id: string;
  organization_name: string | null;
  date: string | null;
  number: string | null;
  amount: number | null;
  contractor_name: string | null;
  /** Радіо «паперовий оригінал» увімкнено для org цього рядка. */
  paper_original?: boolean;
}

/** Конверт серверної пагінації реєстру непідписаних (2026-08-22). */
export interface UnsignedPage {
  enabled: boolean;
  paper_original?: boolean;
  types: string[];
  items: UnsignedRow[];
  total: number;
  limit: number;
  offset: number;
}

export const signControl = {
  settings: (organizationId: string) =>
    api.get<SignControlSettings>('/sign-control/settings', {
      params: { organization_id: organizationId } }).then((r) => r.data),
  saveSettings: (organizationId: string, body: {
    enabled: boolean; paper_original: boolean; types: string[] }) =>
    api.put('/sign-control/settings', body, {
      params: { organization_id: organizationId } }),
  statuses: (organizationId: string, documentType: string, ids: string[]) =>
    api.post<{ enabled: boolean; controlled: boolean; paper_original: boolean;
      statuses: Record<string, SignStatus> }>(
      '/sign-control/statuses',
      { document_type: documentType, ids },
      { params: { organization_id: organizationId } }).then((r) => r.data),
  mark: (organizationId: string, body: {
    document_type: string; document_id: string; kind: 'SCAN' | 'PAPER';
    attachment_id?: string | null; comment?: string | null }) =>
    api.post('/sign-control/mark', body, {
      params: { organization_id: organizationId } }),
  unmark: (organizationId: string, documentType: string, documentId: string) =>
    api.delete('/sign-control/mark', { params: {
      organization_id: organizationId, document_type: documentType,
      document_id: documentId } }),
  unsigned: (params: { organization_id?: string; document_type?: string;
    contractor_id?: string; date_from?: string; date_to?: string;
    sort_by?: string; sort_dir?: 'asc' | 'desc';
    limit?: number; offset?: number }) =>
    api.get<UnsignedPage>('/sign-control/unsigned', { params })
      .then((r) => r.data),
};

export const SIGN_STATUS_LABELS: Record<SignStatus, string> = {
  SIGNED_EDO: 'підписано ЕЦП',
  SIGNED_SCAN: 'підписаний скан',
  SIGNED_PAPER: 'паперовий оригінал',
  UNSIGNED: 'очікує підписання',
};
